import React from 'react';
interface ReceiptHeaderProps {
  companyInfo: {
    name: string;
    logo: string;
    address: string;
    contact: string;
  };
  receiptNo: string;
  receiptDate: string;
  bookingRef: string;
  gstRegNo: string;
  tourCode: string;
  paymentMethod: string;
  collectedBy: string;
  printedBy: string;
}
export function ReceiptHeader({
  companyInfo,
  receiptNo,
  receiptDate,
  bookingRef,
  gstRegNo,
  tourCode,
  paymentMethod,
  collectedBy,
  printedBy
}: ReceiptHeaderProps) {
  return <div className="mb-8" data-id="element-1013">
      <div className="flex justify-between items-start mb-8" data-id="element-1014">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-1015">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-1016">
            <span className="text-white font-bold text-xl" data-id="element-1017">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-1018">
            {companyInfo.name}
          </h1>
          <div className="text-xs text-neutral-600 whitespace-pre-line leading-relaxed" data-id="element-1019">
            {companyInfo.address}
          </div>
          <div className="text-xs text-neutral-600 mt-2" data-id="element-1020">
            {companyInfo.contact}
          </div>
        </div>

        {/* Right: Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-1021">
          <div className="space-y-2" data-id="element-1022">
            <div className="flex justify-between" data-id="element-1023">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1024">
                Receipt No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1025">
                {receiptNo}
              </span>
            </div>

            <div className="flex justify-between" data-id="element-1026">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1027">
                Receipt Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1028">{receiptDate}</span>
            </div>

            <div className="flex justify-between" data-id="element-1029">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1030">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1031">{bookingRef}</span>
            </div>

            <div className="flex justify-between" data-id="element-1032">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1033">
                GST Reg. No.:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1034">{gstRegNo}</span>
            </div>

            <div className="flex justify-between" data-id="element-1035">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1036">
                Tour Code:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1037">{tourCode}</span>
            </div>

            <div className="h-px bg-neutral-200 my-2" data-id="element-1038" />

            <div className="flex justify-between" data-id="element-1039">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1040">
                Payment Method:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1041">{paymentMethod}</span>
            </div>

            <div className="flex justify-between" data-id="element-1042">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1043">
                Collected By:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-1044">
                {collectedBy}
              </span>
            </div>

            <div className="flex justify-between" data-id="element-1045">
              <span className="text-xs font-medium text-neutral-600" data-id="element-1046">
                Printed By:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-1047">{printedBy}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <div className="text-center mb-6" data-id="element-1048">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight" data-id="element-1049">
          OFFICIAL RECEIPT
        </h2>
      </div>
    </div>;
}